import { useSelector } from 'react-redux'
import useSWR from 'swr'
import { coreApi } from '../../../services/api'
import { RootState } from '../../../store/modules/rootReducer'
import { IStudyTime } from '../components/DashboardContent/types'

export const fetcher = (url: string) => coreApi.get(url).then((res) => res.data)

export const useGetStudyTime = (courseId: string | null | undefined) => {
  const student = useSelector((state: RootState) => state.student)

  const key = courseId
    ? `/students/dashboard/student/${student.profile._id}/course/${courseId}/study-time`
    : null

  const options = {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  }

  return useSWR<IStudyTime>(key, fetcher, options)
}
